import { render } from "./indextwofeature.vue?vue&type=template&id=3df9b1b6"
import script from "./indextwofeature.vue?vue&type=script&lang=js"
export * from "./indextwofeature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__